import {SectionSettingsModeEnum, writeSectionSettingsMode} from "@/scripts/sections/sectionSettings/sectionSettingsMode.js";

export default {
    updateSidebarState(state, payload) {
        Object.assign(state.sidePanelSettings, payload);
    },
    setSectionSettingsMode(state, mode) {
        state.sectionSettingsMode = mode === SectionSettingsModeEnum.DOCKED ? SectionSettingsModeEnum.DOCKED : SectionSettingsModeEnum.FLOATING;
        writeSectionSettingsMode(state.sectionSettingsMode);
        if (state.sectionSettingsMode !== SectionSettingsModeEnum.DOCKED) {
            state.dockedSectionSettings = null;
        }
    },
    setDockedSectionSettings(state, settings) {
        state.dockedSectionSettings = settings;
    },
    // Clears only when the given owner is still the one shown, so a late close can't wipe a newer selection.
    clearDockedSectionSettings(state, ownerKey) {
        if (!ownerKey || state.dockedSectionSettings?.ownerKey === ownerKey) {
            state.dockedSectionSettings = null;
        }
    }
}
